<template>
  <div>
    <div class="form-group">
      <div class="input-group mr-1">
        <input-comp v-model="filtros.folio.value" @change="addFilter" label="Folio"/>
      </div>
      <div class="input-group mr-1">
        <label for="fecha">Fecha</label>
        <input pattern="[0-9]{4}/[0-9]{2}/[0-9]{2}" v-model="filtros.fecha.value" id="fecha" @change="addFilter"
               type="date">
        <i class="bar"></i>
      </div>
      <div class="input-group mr-1">
        <label for="usuario">Usuario</label>
        <select v-model="filtros.usuario.value" @change="addFilter" name="usuario" id="usuario">
          <option value="">Seleccione...</option>
          <option v-for="item in usuarios" :value="item.nombre">{{item.nombre}}</option>
        </select>
        <i class="bar"></i>
      </div>
      <div class="input-group mr-1">
        <label for="estado">Estado</label>
        <select @change="addFilter" v-model="filtros.estado.value" name="estado" id="estado">
          <option value="">Seleccione...</option>
          <option value="pendiente">Pendiente</option>
          <option value="revisado">Revisado</option>
          <option value="revisado_observacion">Revisado Observacion</option>
        </select>
        <i class="bar"></i>
      </div>
      <div class="input-group">
        <label for="sucursal">Sucursal Destino</label>
        <select @change="addFilter" v-model="filtros.sucursal" name="sucursal" id="sucursal">
          <option value="">Seleccione...</option>
          <option v-for="item in sucursales" :value="item">{{item.nombre}}</option>
        </select>
        <i class="bar"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import InputComp from "../../Componentes_Globales/Input/inputComp";
  import moment from "moment";

  export default {
    name: "filtrosRecepcionGuia",
    components: {InputComp},
    computed: {
      usuarios() {
        return this.$store.getters.usuarios
      },
      sucursales() {
        return this.$store.getters.sucursales
      }
    },
    methods: {
      addFilter() {
        if (this.filtros.sucursal === "")
          this.$emit("addFilter", {filtros: this.makeFiltros(), isSucursalDestino: false, sucursal: ""})
        else
          this.$emit('getGuiasSucursalDestino',
            {filtros: this.makeFiltros(), isSucursalDestino: true, sucursal: this.filtros.sucursal})
      },
      makeFiltros() {
        let filtros = []
        if (this.filtros.folio.value !== "")
          filtros.push(this.filtros.folio)
        if (this.filtros.fecha.value !== "")
          filtros.push({...this.filtros.fecha, value: moment(this.filtros.fecha.value).format("DD/MM/YYYY")})
        if (this.filtros.usuario.value !== "")
          filtros.push(this.filtros.usuario)
        if (this.filtros.estado.value !== "")
          filtros.push(this.filtros.estado)
        return filtros
      }
    },
    created() {
      this.$store.dispatch("loadUsuarios")
      this.$store.dispatch("loadSucursal")
    },
    data() {
      return {
        filtros: {
          folio: {field: 'folio', value: "", operator: '='},
          fecha: {field: 'fecha', value: "", operator: 'CONTAINS'},
          usuario: {field: 'usuario_nombre', value: "", operator: 'CONTAINS'},
          estado: {field: "estado", value: "", operator: "="},
          sucursal: ""
        }
      }
    }
  }
</script>

<style scoped>

</style>
